import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@material-ui/core";

export default function SkeletonComponent(props) {
  return (
    <div>
      <Box py={1}>
        <Skeleton height={100} variant="rect" />
      </Box>
      <Box py={1}>
        <Skeleton height={100} variant="rect" />
      </Box>
      <Box py={1}>
        <Skeleton height={100} variant="rect" />
      </Box>
      <Box py={1}>
        <Skeleton height={100} variant="rect" />
      </Box>
      <Box py={1}>
        <Skeleton height={100} variant="rect" />
      </Box>
      <Box py={1}>
        <Skeleton height={100} variant="rect" />
      </Box>
    </div>
  );
}
